<template>
  <div class="product-show">
    <div class="product-show-container">
      <el-row>
        <el-col :span="24">
          <h1 class="title">产品系列展示</h1>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="custom-tabs">
            <div
              v-for="tab in tabs"
              :key="tab"
              :class="['custom-tab', { active: activeTab === tab }]"
              @click="handleTabClick(tab)"
            >
              {{ tab }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        style="
          position: relative;
          border-radius: 8px;
          background: linear-gradient(
            250deg,
            rgba(255, 255, 255, 0.8) 1%,
            rgba(255, 255, 255, 0.6) 99%
          );
          border: 1px solid #ffffff;
          background-color: #fff;
          backdrop-filter: blur(40px);
          height: 574px;
          box-shadow: 6px 6px 16px 0px rgba(30, 36, 42, 0.04),
            -6px -6px 16px 0px rgba(255, 255, 255, 0.6);
        "
      >
        <el-col :span="7" class="uavLeft">
          <div class="uav_til">{{ activeTab }}</div>
          <div v-for="item in tab1" class="uav_item">
            <img
              src="@/assets/home/dui.png"
              alt="对号"
              class="checkmark-icon"
            />
            {{ item }}
          </div>
        </el-col>
        <el-col :span="17">
          <div class="button-group">
            <button
              v-for="(item, index) in menuItems"
              :key="index"
              :class="['menu-button', { active: selectedButton === index }]"
              @click="handleButtonClick(index, item.text)"
            >
              {{ item.text }}
            </button>
          </div>
          <div class="button-details">
            <div class="model-header">
              <img :src="bigImg" alt="大图片" class="model-image" />
            </div>
            <h2 class="button-title">
              {{ (menuItems[selectedButton].text || "").replace(/\s+/g, "") }}
            </h2>
            <p class="button-description">
              {{ menuItems[selectedButton].desc }}
            </p>
            <a href="#" class="learn-more" @click.prevent="handleLearnMoreClick"
              >了解更多 ></a
            >
            <!-- 型号及按钮区域仅在非“软件系统”时显示 -->
            <template
              v-if="
                activeTab !== '软件系统' &&
                activeTab !== '陆空协同无人车（机器人）' &&
                activeTab !== '海空协同无人船（艇）' &&
                activeTab !== '其他产品' &&
                activeTab !== '移动航空站' &&
                
                activeTab !== '边端算力服务器' &&
                activeTab !== '云端算力服务器'
              "
            >
              <h2
                class="model-title"
                v-if="
                  menuItems[selectedButton].text !== '移动航空站' &&
                  menuItems[selectedButton].text !== '无人装备指挥车' &&
                  menuItems[selectedButton].text !== '机载智能大脑' &&
                  menuItems[selectedButton].text !== '边端算力服务器' &&
                  menuItems[selectedButton].text !== '云端算力服务器' "
              >
                型号
              </h2>
              <!-- {{ menuItems[selectedButton] }} -->
              <div
                class="detail-buttons"
                :class="{
                  'two-columns':
                    menuItems[selectedButton].detailButtons.length > 2,
                }"
              >
                <button
                  v-for="(detail, index) in menuItems[selectedButton]
                    .detailButtons"
                  :key="index"
                  :class="[
                    'detail-button',
                    { active: selectedDetailButton === index },
                  ]"
                  @click="handleDetailButtonClick(index, detail.text)"
                >
                  <img :src="detail.icon" alt="icon" class="detail-icon" />
                  {{ detail.text }}
                </button>
              </div>
            </template>
          </div>
        </el-col>
        <!-- <el-col :span="18">
        <div class="right">
          <h2>集群式换电航站</h2>
          <p>双机系列机场特点，支持多种任务模式...</p>
          <el-carousel :interval="4000" type="card" height="200PX">
            <el-carousel-item v-for="item in 4" :key="item">
              <img src="path/to/image.png" alt="集群式换电航站">
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import { getDeptListById } from "@/api/dataManeger.js";
export default {
  name: "ProductShow",
  data() {
    return {
      activeTab: "地空协同智能航空站（自动机场）",
      tab1: [
        "可提供固定式及移动式产品类型，满足不同场景多模态作业需求",
        "满足巡查巡检、公安防务、应急处突、边海巡防等应用领域需求",
        "融合AI智能调度与物联网技术，实现异构无人机集群自主作业",
      ],
      bigImg: "https://hr2.chnsoft.com.cn/img/D51.png",
      tabs: [
        "地空协同智能航空站（自动机场）",
        "陆空协同无人车（机器人）",
        "海空协同无人船（艇）",
        "软件系统",
        "全国产化智能大、小脑（服务器）",
        "其他产品",
      ],
      menuItems: [
        {
          text: "集群式换电航站",
          desc: "集群式换电航站，搭载两架无人机，双机协同工作，可同时执行不同的作业任务或交替执行同一任务，确保“飞的准”“飞的稳”“一直飞”“交替飞”“协同飞”。 ",

          detailButtons: [
            {
              text: "D51型号",
              icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            },
            {
              text: "D55型号",
              icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            },
          ],
        },
        {
          text: "换电式自动机场",
          desc: "换电系列机场的特点描述...",
          detailButtons: [
            // {
            //   text: "V140型号",
            //   icon: "https://hr2.chnsoft.com.cn/img/V140.png",
            // },
            // {
            //   text: "V130型号",
            //   icon: "https://hr2.chnsoft.com.cn/img/V130.png",
            // },
            {
              text: "V350型号",
              icon: "https://hr2.chnsoft.com.cn/img/V350.png",
            },
            {
              text: "V232型号",
              icon: "https://hr2.chnsoft.com.cn/img/V232.png",
            },
            {
              text: "V400型号",
              icon: "https://hr2.chnsoft.com.cn/img/V400.png",
            },
          ],
        },
        {
          text: "充电式自动机场",
          desc: "充电系列机场的特点描述...",

          detailButtons: [
            // {
            //   text: "C140型号",
            //   icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            // },
            // {
            //   text: "C130型号",
            //   icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            // },
            {
              text: "C350型号",
              icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            },
          ],
        },
        {
          text: "垂起固定翼机场",
          desc: "垂起固定翼机场的特点描述...",

          detailButtons: [
            {
              text: "VF7型号",
              icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            },
          ],
        },
        {
          text: "大载重自动机场",
          desc: "大载重机场的特点描述...",

          detailButtons: [
            {
              text: "WF30型号",
              icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
            },
          ],
        },
      ],
      selectedButton: 0,
      selectedDetailButton: 0,
      tabRouteMap: [
        { text: "集群式换电航站", route: "product_lie_1" },
        { text: "换电式自动机场", route: "product_lie_2" },
        { text: "充电式自动机场", route: "product_lie_3" },
        { text: "垂起固定翼机场", route: "product_lie_4" },
        { text: "大载重自动机场", route: "product_lie_5" },
        { text: "空地一体母站", route: "product_lie_5_1" },
        { text: "移动航空站", route: "product_lie_6" },
        { text: "无人装备指挥车", route: "product_lie_7" },
        { text: "陆空协同无人消防车", route: "product_lie_8" },

        { text: "涡扇炮智能消防车", route: "product_lie_8" },
        { text: "陆空协同无人消防车", route: "product_lie_8" },
        { text: "陆空协同应急处置机器人", route: "product_lie_9" },
        { text: "陆空协同智能巡视机器人", route: "product_lie_8_1" },
        { text: "室内应急处置机器人", route: "product_lie_8_2" },
        { text: "海空协同无人船（艇）", route: "product_lie_10" },
        { text: "空海一体智能无人艇", route: "product_lie_10" },
        { text: "T750无人艇", route: "product_lie_10" },
        { text: "T160无人船", route: "product_lie_10" },
        { text: "T240无人船", route: "product_lie_10" },
        { text: "T130测流无人船", route: "product_lie_10" },
        { text: "T095无人船", route: "product_lie_10" },

        { text: "电动遥控救生圈", route: "product_lie_10" },

        { text: "智能全域巡视系统", route: "product_lie_11" },
        { text: "智能全域巡视系统", route: "product_lie_11" },

        { text: "全域电网巡检系统", route: "product_lie_12" },
        { text: "全域电网巡检系统", route: "product_lie_12" },
        { text: "机载智能大脑", route: "product_lie_13" },
        { text: "车(船)载智能大(小)脑", route: "product_lie_13_1" },
        { text: "边端算力服务器", route: "product_lie_13_2" },
        { text: "云端算力服务器", route: "product_lie_14" },

        { text: "系留供电装置", route: "product_lie_15" },
        { text: "系留供电装置", route: "product_lie_15" },
        { text: "无人装备便携地面站", route: "product_lie_16" },
        { text: "无人装备便携地面站", route: "product_lie_16" },
        { text: "机载任务系统", route: "product_lie_18" },
        { text: "AMS-400-V112  机载任务系统", route: "product_lie_18" },
        { text: "无人装备驾控台", route: "product_lie_17" },
        { text: "无人装备驾控台", route: "product_lie_17" },
      ],
    };
  },
  mounted() {
    // this.getDeptById();
    this.handleTabClick(this.activeTab);
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab;
      // this.handleButtonClick(0)
      switch (tab) {
        case "地空协同智能航空站（自动机场）":
          // this.handleDetailButtonClick(0, 'D51型号');
          this.bigImg = "https://hr2.chnsoft.com.cn/img/D51.png";
          this.menuItems = [
            {
              text: "集群式换电航站",
              desc: "集群式换电航站，搭载两架无人机，双机协同工作，可同时执行不同的作业任务或交替执行同一任务，确保“飞的准”“飞的稳”“一直飞”“交替飞”“协同飞”。 ",

              detailButtons: [
                {
                  text: "D51型号",
                  icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
                },
                {
                  text: "D55型号",
                  icon: "https://hr2.chnsoft.com.cn/img/uavSmall.png",
                },
              ],
            },
            {
              text: "换电式自动机场",
              desc: "换电式自动机场系列产品是专为工业无人机打造的智能化作业中枢，适配多类型轻小型无人机。集成电池快换、环境感知、远程控制等核心功能，实现无人机“作业-换电-再作业”全流程自动化，突破续航瓶颈，赋能高效作业闭环。",

              detailButtons: [
                // {
                //   text: "V140型号",
                //   icon: "https://hr2.chnsoft.com.cn/img/V140.png",
                // },
                // {
                //   text: "V130型号",
                //   icon: "https://hr2.chnsoft.com.cn/img/V130.png",
                // },
                {
                  text: "V350型号",
                  icon: "https://hr2.chnsoft.com.cn/img/V350.png",
                },
                {
                  text: "V232型号",
                  icon: "https://hr2.chnsoft.com.cn/img/V232.png",
                },
                {
                  text: "V400型号",
                  icon: "https://hr2.chnsoft.com.cn/img/V400.png",
                },
              ],
            },
            {
              text: "充电式自动机场",
              desc: "充电式自动机场采用轻量化设计，适配多类型轻小型无人机，是集智能充电、自主起降、通讯保障、环境感知、远程控制等核心功能的一体化无人机自主作业平台，部署方便、经济便捷。",

              detailButtons: [
                // {
                //   text: "C140型号",
                //   icon: "https://hr2.chnsoft.com.cn/img/C140.png",
                // },
                // {
                //   text: "C130型号",
                //   icon: "https://hr2.chnsoft.com.cn/img/C130.png",
                // },
                {
                  text: "C350型号",
                  icon: "https://hr2.chnsoft.com.cn/img/C350.png",
                },
                {
                  text: "C400型号",
                  icon: "https://hr2.chnsoft.com.cn/img/C400.png",
                },
              ],
            },
            {
              text: "垂起固定翼机场",
              desc: "垂起固定翼机场作为垂起固定翼系列无人机的停靠站、通信站和换电站，为垂起固定翼无人机提供一站式保障服务，在无人值守的状态下，依靠该终端能够实现无人机智能化巡查、巡检、巡逻与应急处置等多用途行业综合应用。",

              detailButtons: [
                {
                  text: "VF7型号",
                  icon: "https://hr2.chnsoft.com.cn/img/VF7.png",
                },
              ],
            },
            {
              text: "大载重自动机场",
              desc: "大载重自动机场为DJI FlyCart30无人机量身打造，兼顾无人机电池与载荷双重自动更换功能。航空站内部储存多组无人机备用电池与灭火弹（载荷可定制），具备自主起降、自动更换、精准投递、智能决断等突出特点，满足消防、运输、救援多种场景部署使用。",

              detailButtons: [
                {
                  text: "WF30型号",
                  icon: "https://hr2.chnsoft.com.cn/img/WF30.png",
                },
              ],
            },
            {
              text: "空地一体母站",
              desc: "IAS-D441空地一体母站，是集空地协同、群体智能与智能保障于一体的新一代无人化作业基础设施；可为站内两架无人机与一台四足机器人进行集群调度、任务规划、自动换电/充电等全流程运维支持；凭借工业级温湿调控、强电磁兼容设计与长效UPS供电，确保在极端环境下为整个无人化作业集群提供持续、稳定的支援与保障。",
              // detailButtons: [],
              detailButtons: [
                {
                  text: "IAS-D441",
                  icon: "https://hr2.chnsoft.com.cn/img/空地一体母站.png",
                },
              ],
            },

            {
              text: "移动航空站",
              desc: "“移动航空站”将越野皮卡与智能航空站有机整合，构建空地协同移动作业平台。具备复杂地形适应能力，支持无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。依托车载操控终端，实现航线规划、自主飞行、数据采集与AI智能识别的全流程自动化，极大提升野外巡检作业的效率与范围。",
              detailButtons: [],
            },
            {
              text: "无人装备指挥车",
              desc: "一站式空地协同移动作业平台。可同时集控4架无人机，实现无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。融合5G通信、远程会议、数据分析、图像处理等多项技术手段，可作为应急移动指挥系统，实现前沿视频图像采集、AI智能识别与现场决策指挥，满足户外巡检、应急救援等各类应用场景需求，提升作业、指挥效率与响应速度。",
              detailButtons: [],
            },
          ];
          this.tab1 = [
            "可提供固定式及移动式产品类型，满足不同场景多模态作业需求",
            "满足巡查巡检、公安防务、应急处突、边海巡防等应用领域需求",
            "融合AI智能调度与物联网技术，实现异构无人机集群自主作业",
          ];
          break;
        // case '移动航空站系列':
        //   this.bigImg = require('@/assets/home/移动航空站.png');
        //   this.menuItems = [
        //     {
        //       text: '移动航空站',
        //       desc: '“移动航空站”将越野皮卡与智能航空站有机整合，构建空地协同移动作业平台。具备复杂地形适应能力，支持无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。依托车载操控终端，实现航线规划、自主飞行、数据采集与AI智能识别的全流程自动化，极大提升野外巡检作业的效率与范围。',
        //       detailButtons: []
        //     },
        //     {
        //       text: '无人装备指挥车',
        //       desc: '一站式空地协同移动作业平台。可同时集控4架无人机，实现无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。融合5G通信、远程会议、数据分析、图像处理等多项技术手段，可作为应急移动指挥系统，实现前沿视频图像采集、AI智能识别与现场决策指挥，满足户外巡检、应急救援等各类应用场景需求，提升作业、指挥效率与响应速度。',
        //       detailButtons: []
        //     }
        //   ];
        //   this.tab1 = [
        //     '移动航空站创新融合无人机与车载技术，打造高效、灵活的空中作业解决方案',
        //     '为无人机应用拓展无限可能',
        //     '打造移动场景下无人机作业的综合保障体系'
        //   ];
        //   break;
        case "陆空协同无人车（机器人）":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/应急处置机器人.png";
          this.menuItems = [
            {
              text: "陆空协同应急处置   机器人",
              desc: "陆空协同应急处置机器人，首创无人化陆空协同立体消防作业平台。集成了智能消防无人机、高效水雾炮系统、全地形底盘、自主导航避障系统与远程集控平台，构建了完整的无人化陆空协同消防作业体系。具备全天候、全地形作战能力，可在火灾初期快速介入，实现“侦测-定位-压制”一体化作战，有效执行高危环境下的灭火任务，显著提升灭火效率，最大限度保障人员安全与现场秩序。",
              detailButtons: [
                {
                  text: "R50型号",
                  icon: "https://hr2.chnsoft.com.cn/img/应急处置机器人.png",
                },
              ],
            },
            {
              text: "陆空协同无人消防车",
              desc: "本产品基于成熟消防车平台改装，融合无人驾驶、无人机自动机场及智能火情识别系统。无人机空中自主巡火与定位，智能消防车自动行驶抵近灭火。形成“空中侦察-定位-地面无人精准灭火”的陆空协同作业闭环，有效提升灭火效率并保障人员安全，适用于化工、森林等多种复杂火灾场景。",
              detailButtons: [
                {
                  text: "886型号",
                  icon: "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车.png",
                },
              ],
            },
            {
              text: "涡扇炮智能消防车",
              desc: "DFT-M02-V10 涡扇炮智能消防车由车辆底盘、消防车无人智能系统、数据传输系统、远程控制系统组成。通过泵组将水和泡沫原液按比例混合后，经细水雾喷头，再由涡扇强力吹射，分解为更细小的雾滴，有效增加灭火面积，提高灭火效率。",
              detailButtons: [
                {
                  text: "DFT-M02-V10",
                  icon: "https://hr2.chnsoft.com.cn/img/涡扇炮智能消防车.png",
                },
              ],
            },
            {
              text: "陆空协同智能巡视 机器人",
              desc: "陆空协同智能巡视机器人，通过履带底盘、无人机巡检系统及自动寻火探测技术，实现远程高效精准灭火，保障人员与设备安全。",
              detailButtons: [],
            },
            {
              text: "室内应急处置机器人",
              desc: "室内应急处置机器人体积小巧，具备室内自动导航定位、火源定位、应急处置等功能，可穿梭在室内复杂环境中，对室内设施进行巡检、灭火等综合应用。",
              detailButtons: [],
            },
          ];
          this.tab1 = [
            "无人车与无人机深度融合、协同作业的系列产品",
            "集成自动驾驶、自动寻火、自动灭火、态势侦测、应急指挥等功能",
            "可自主导航并完成精准处置任务",
          ];
          break;
        case "海空协同无人船（艇）":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/水上智能航空站.png";
          this.menuItems = [
            {
              text: "空海一体智能无人艇",
              desc: "革新水域作业模式，自主导航精准避障，超长续航无惧复杂水域。无人机与无人船智能协同，空中广域扫描污染/热源，水面同步采集水质/声纳数据，构建立体监控网络。全面赋能环保巡查、应急救援、海上巡检，以全流程自动化替代高危人工作业，树立安全、高效、智能化的水域管理新标杆。",
              detailButtons: [],
            },
            {
              text: "T750无人艇",
              desc: "T750区域警戒巡逻无人艇是一款具备智能化、高效性和适应性的智能水面无人装备，搭载了先进的智能控制系统，能够高效地完成对目标区域的监控和巡逻任务。",
              detailButtons: [],
            },
            {
              text: "T160无人船",
              desc: "T160多功能水面无人船以江河流域、湖泊水库、近海沿岸、港口码头等流域为主要应用场景，可搭载集成水质采样器、多参数水质分析仪、侧扫声呐、ADCP、单波束测深仪等专业仪器。",
              detailButtons: [],
            },
            {
              text: "T240无人船",
              desc: "T240多功能水面无人船以江河流域、湖泊水库、近海沿岸、港口码头等流域为主要应用场景，可搭载集成水质采样器、多参数水质分析仪、侧扫声呐、ADCP、单波束测深仪等专业仪器。",
              detailButtons: [],
            },
            {
              text: "T130测流无人船",
              desc: "T130测流无人船以江河湖泊、水库、海岸、码头等流域为主要应用场景，采用自主研发涵道式推进器，纯电力推进，防缠绕设计，支持倒车航行，推进器与船体底部齐平，布放与回收方便。",
              detailButtons: [],
            },
            {
              text: "T095无人船",
              desc: "T095 水面采样/监测无人船以河湖、水库等水域为主要应用场景，可同时搭载水质采样器和多参数水质在线监测仪，ADCP、单波束测深仪、侧扫声呐等设备。",
              detailButtons: [],
            },

            {
              text: "电动遥控救生圈",
              desc: "电动遥控救生圈是一种新型的水上救援设备，结合了传统救生圈和现代电动推进技术，旨在提高水上救援的效率和安全性。该设备配备了电动推进系统，可以通过遥控器进行远程操控，使其能够快速到达落水者身边，提供及时的救援支持。",
              detailButtons: [],
            },
          ];
          this.tab1 = [
            "革新水域作业模式，自主导航精准避障，超长续航无惧复杂水域",
            "无人机与无人船智能协同，空中广域扫描污染/热源，水面同步采集水质/声纳数据，构建立体监控网络",
            "全面赋能环保巡查、应急救援、海上巡检，以全流程自动化替代高危人工作业，实现安全、高效、智能化的水域管理新标杆",
          ];
          break;
        case "软件系统":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/ruanJian1.png";
          this.menuItems = [
            {
              text: "智能全域巡视系统",
              desc: "是面向立体空间的全维度无人化智能巡视解决方案，核心实现空、地、海无人装备作业的一体化管控，突破多场景壁垒，织就贯通空、地、海立体巡视网，依托于异构协同、人工智能、边缘计算等新兴技术，实现从装备调度到数据研判的全链条自动化，为各领域筑牢高效精准的全域态势感知屏障。",
              detailButtons: [
                // 无icon
              ],
            },
            {
              text: "全域电网巡检系统",
              desc: "聚焦输电、变电、配网、直流四大核心专业，以无人机、无人车为核心作业单元，深度融合数字孪生、AI 智能分析、北斗高精度定位等前沿技术，构建覆盖“空-天-地”一体化的全域无人化巡检体系。系统打通从任务智能规划、自主巡检执行、缺陷智能识别到运维闭环管控的全业务链条，彻底颠覆传统人工巡检模式，为电网运维提供安全、高效、精准的数字化、智能化升级解决方案，筑牢新型电力系统安全稳定运行基石。  ",
              detailButtons: [
                // 无icon
              ],
            },
          ];
          this.tab1 = [
            "无人化装备核心系统平台，融合国产AI多模态大模型，实现多模态信息融合",
            "为各行业系统安全稳定运行提供智能化保障",
            "集管理、控制、任务调度、监控与分析于一体",
            "模块化设计确保高效精准执行巡检、巡查、应急处置等任务",
          ];
          break;
        case "全国产化智能大、小脑（服务器）":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/机载智能大脑.png";
          this.menuItems = [
            {
              text: "机载智能大脑",
              desc: "扩展多类型通信链路，丰富的外部接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人机集控飞行系统中的态势感知、自主决策自主执行和数据运算处理软硬一体化工业级智能体。",
              detailButtons: [],
            },
            {
              text: "车(船)载智能大(小)脑",
              desc: "采用车（船）规制通信链路及感知、控制接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人车（船）自主态势感知、自主决策自主执行和数据运算处理的软硬一体化车（船）级智能体。",
              detailButtons: [
                // {
                //   text: "ZF-A400",
                //   icon: "https://hr2.chnsoft.com.cn/img/ZF-A400 算力板卡.png",
                // },
                {
                  text: "ZF-E2000-Q AIBOX",
                  icon: "https://hr2.chnsoft.com.cn/img/ZF-E2000-Q AIBoxBox.png",
                },
                {
                  text: "ZF-D2000-Q AIBOX",
                  icon: "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png",
                },
                {
                  text: "ZF-3588",
                  icon: "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png",
                },
              ],
            },
            {
              text: "边端算力服务器",
              desc: "边缘算力节点，为全系列产品提供智能决策支撑。",
              detailButtons: [],
            },
            {
              text: "云端算力服务器",
              desc: "云端算力核心，为全系列产品提供智能决策支撑。",
              detailButtons: [
                // {
                //   text: "ZF-C200",
                //   icon: "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png",
                // },
                // {
                //   text: "ZF-S5000",
                //   icon: "https://hr2.chnsoft.com.cn/img/ZF-S5000算力服务器.png",
                // },
              ],
            },
            // {
            //   text: "机载板卡",
            //   desc: "作为自主创新战略的深度践行者，智能算力板卡以全栈自主可控为核心设计理念，深度融合算力服务领域的前沿技术与尖端成果，为人工智能、边缘计算、大规模数据中心等高复杂度场景提供安全、高效、可扩展的算力解决方案。  ",
            //   detailButtons: [
            //     {
            //       text: "ZF-A400",
            //       icon: "https://hr2.chnsoft.com.cn/img/ZF-A400 算力板卡.png",
            //     },
            //     {
            //       text: " ZF-E2000-Q AIBOX",
            //       icon: "https://hr2.chnsoft.com.cn/img/ZF-E2000-Q AIBoxBox.png",
            //     },
            //     {
            //       text: "ZF-D2000-Q AIBOX",
            //       icon: "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png",
            //     },
            //     {
            //       text: "ZF-3588",
            //       icon: "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png",
            //     },
            //   ],
            // },
          ];
          this.tab1 = [
            "以国产化算力芯片为基础，秉持自主创新理念，打造边缘计算终端、高性能算力服务器等全国产化算力产品",
            "专注人工智能与大数据领域，提供高性能计算、边缘计算及定制化解决方案",
            "服务政府、军工、科研等关键行业",
          ];
          break;
        case "其他产品":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/xiliunew.png";
          this.menuItems = [
            {
              text: "系留供电装置",
              desc: "系留供电装置具备坚固耐用、运行稳定、功能丰富、携带便捷等特点，通过复合线缆为无人机提供不低于8小时的稳定供电，最高作业高度可达百米，解决无人机长时间滞空作业难题，突破无人机续航限制。",
              detailButtons: [
                // 无icon
              ],
            },
            {
              text: "无人装备便携地面站",
              desc: "无人装备便携地面站采用拉杆箱式设计，性能稳定、坚固耐用、携带便捷、机动性强，作业时不受环境约束。支持适配绝大多数无人机品牌与类型，能够对多台无人机进行集中管控，具有集群化、智能化应用特点，是一套适用于各行业的无人机单兵便携飞行系统。",
              detailButtons: [
                // 无icon
              ],
            },
            // {
            //   text: "AMS-400-V112  机载任务系统",
            //   desc: "机载任务系统便捷小巧、一体集成，以实时计算为核心。具备实时图像识别与精确定位能力，让目标识别与捕捉更加精准，集成自动飞行算法，可确保无人机作业精准高效，无论是自主航线飞行还是手动操控皆游刃有余。",
            //   detailButtons: [
            //     // 无icon
            //   ],
            // },
            {
              text: "无人装备驾控台",
              desc: "无人装备驾控台是无人机集控飞行解决方案的控制中心节点。部署在指挥调度中心，对整个系统内的各类资源拥有执行调配和管理权限，包括常态化区域内状态管控、临时执勤等任务的制定和下发，远程实时操控任务无人机以及无人机实时信息的反馈及管理等。",
              detailButtons: [
                // 无icon
              ],
            },
          ];
          this.tab1 = [
            "深耕无人装备“无人化、集群化、智能化“应用场景",
            "提供无人装备智能作业全场景解决方案",
            "全方位、多角度地满足各行业用户在不同作业场景下的多样化需求",
          ];
          break;
        default:
          this.menuItems = [];
          this.tab1 = [];
      }
      this.selectedButton = 0;
      this.selectedDetailButton = 0;
    },
    handleSelect(key, keyPath) {},
    handleButtonClick(index, text) {
      this.selectedButton = index;
      if (text == "智能全域巡视系统") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/ruanJian1.png";
      } else if (text == "全域电网巡检系统") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/ruanJian2.png";
      } else if (text == "空海一体智能无人艇") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/水上智能航空站.png";
      } else if (text == "T750无人艇") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/区域警戒巡逻无人艇1x.png";
      } else if (text == "T160无人船") {
        this.bigImg =
          "https://hr2.chnsoft.com.cn/img/T160多功能水面无人船1x.png";
      } else if (text == "T240无人船") {
        this.bigImg =
          "https://hr2.chnsoft.com.cn/img/T240多功能水面无人船1x.png";
      } else if (text == "T130测流无人船") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/T130测流无人船.png";
      } else if (text == "T095无人船") {
        this.bigImg =
          "https://hr2.chnsoft.com.cn/img/T095水面采样监测无人船1x.png";
      } else if (text == "电动遥控救生圈") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/电动遥控救生圈1x.png";
      } else if (text == "移动航空站") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/移动航空站.png";
      } else if (text == "无人装备指挥车") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/应急指挥车.png";
      } else if (text == "系留供电装置") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/xiliunew.png";
      } else if (text == "无人装备便携地面站") {
        this.bigImg =
          "https://hr2.chnsoft.com.cn/img/CGS-C03 集控飞行地面站.png";
      } else if (text == "无人装备驾控台") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/CGS-100 集控飞行座舱.png";
      } else if (text == "AMS-400-V112  机载任务系统") {
        this.bigImg =
          "https://hr2.chnsoft.com.cn/img/AMS-400-V112  机载任务系统.png";
      } else if (text == "陆空协同智能巡视 机器人") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/智能巡视机器人.png";
      } else if (text == "室内应急处置机器人") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/室内应急处置机器人.png";
      } else if (text == "空地一体母站") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/空地一体母站.png";
      } else if (text == "机载智能大脑") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/机载智能大脑.png";
      } else if (text == "车(船)载智能大(小)脑") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png";
      } else if (text == "边端算力服务器") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png";
      } else if (text == "云端算力服务器") {
        this.bigImg = "https://hr2.chnsoft.com.cn/img/ZF-S5000算力服务器.png";
      }
      this.handleDetailButtonClick(
        0,
        this.menuItems[index]?.detailButtons[0]?.text
      );
    },
    handleDetailButtonClick(index, detailText) {
      this.selectedDetailButton = index;
      // 根据 detailText 动态切换 bigImg
      switch (detailText) {
        case "D51型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/D51.png";
          break;
        case "D55型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/D51.png";
          break;
        case "V140型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/V140.png";
          break;
        case "V130型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/V130.png";
          break;
        case "V350型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/V350.png";
          break;
        case "V400型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/V400.png";
          break;
        case "V232型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/V232.png";
          break;
        case "C130型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/C130.png";
          break;
        case "C140型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/C140.png";
          break;
        case "C350型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/C350.png";
          break;
        case "C400型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/C400.png";
          break;
        case "VF7型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/VF7.png";
          break;
        case "WF30型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/WF30.png";
          break;
        case "一架DJI Matrice 350 RTK":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/移动航空站.png";
          break;
        case "1-4架DJI Matrice 350 RTK":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/应急指挥车.png";
          break;

        case "R50型号":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/应急处置机器人.png";
          break;
        case "886型号":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车@1x.png";
          break;
        case "DFT-M02-V10":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/涡扇炮智能消防车@1x.png";
          break;
        case "海空协同无人船（艇）":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/区域警戒巡逻无人艇.png";
          break;
        case "ZF-C200":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png";
          break;

        case "ZF-S5000":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/ZF-S5000算力服务器.png";
          break;
        case "ZF-A400":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/ZF-A400 算力板卡.png";
          break;
        case "ZF-E2000-Q AIBOX":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/ZF-E2000-Q AIBoxBox.png";
          break;
        case "ZF-D2000-Q AIBOX":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png";
          break;
        case "ZF-3588":
          this.bigImg =
            "https://hr2.chnsoft.com.cn/img/ZF-D2000 AIBox&ZF-3588 AIBox.png";
          break;

        case "智能全域巡视系统":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/ruanJian1.png";
          break;
        case "全域电网巡检系统":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/ruanJian2.png";
          break;

        // case "ZF-E2000-Q AIBOX":
        //   this.bigImg =
        //     "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png";
        //   break;

        case "UMS-V22":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/xiliunew.png";
          break;
        case "CGS-C03":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/CGSC03.png";
          break;
        case "机载智能大脑":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/AMS400V112.png";
          break;
        case "CGS-100":
          this.bigImg = "https://hr2.chnsoft.com.cn/img/CGS100.png";
          break;

        // default:
        //   this.bigImg = require('@/assets/home/D51.png');
      }
    },
    async getDeptById() {
      getDeptListById({ id: "1912327945257005057" }).then((res) => {
        if (res) {
          // res.result[0].children.forEach(item => {
          //   item.category = res.result[0].name; // 添加分类属性
          // });
          // this.cases = res.result[0].children                    // 在此处理接口返回的数据
          // console.log('Dept List:', res);
        }
      });
    },
    setProductLocalStorage(text) {
      if (text) {
        localStorage.setItem("selectedText", text);
        if (text == "海空协同无人船（艇）") {
          localStorage.setItem("TeDianBgProName", "水上智能航空站");
        } else if (text == "陆空协同无人消防车") {
          localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
        } else if (text == "算力服务器") {
          localStorage.setItem("TeDianBgProName", "ZF-C200 边缘计算终端");
        } else if (text == "机载板卡") {
          localStorage.setItem("TeDianBgProName", "ZF-A400 算力板卡");
        } else if (text == "系留供电装置") {
          localStorage.setItem("TeDianBgProName", "系留供电装置");
        } else if (text == "无人装备便携地面站") {
          localStorage.setItem("TeDianBgProName", "无人装备便携地面站");
        } else if (text == "机载任务系统") {
          localStorage.setItem("TeDianBgProName", "AMS-400-V112 机载任务系统");
        } else if (text == "无人装备驾控台") {
          localStorage.setItem("TeDianBgProName", "无人装备驾控台");
        } else if (text == "智能全域巡视系统") {
          localStorage.setItem("TeDianBgProName", "智能全域巡视系统");
        } else if (text == "全域电网巡检系统") {
          localStorage.setItem("TeDianBgProName", "全域电网巡检系统");
        } else {
          localStorage.setItem("TeDianBgProName", text);
        }
      }
    },
    handleLearnMoreClick() {
      // console.log(2222221111111);
      localStorage.setItem("activeNav", "product");
      // 获取当前tab的映射title
      let tabTitle = this.activeTab;
      // 获取当前选中的按钮文本
      const btnText = this.menuItems[this.selectedButton]?.text.replace(
        /\s+/g,
        ""
      );
      let seTxt = btnText.replace(/\s+/g, "");
      if (btnText == "涡扇炮智能消防车" || btnText == "陆空协同无人消防车") {
        seTxt = "陆空协同无人消防车";
      }
      if (
        btnText == "空海一体智能无人艇" ||
        btnText == "T750无人艇" ||
        btnText == "T160多无人船" ||
        btnText == "T240无人船" ||
        btnText == "T130测流无人船" ||
        btnText == "T095无人船" ||
        btnText == "电动遥控救生圈"
      ) {
        seTxt = "海空协同无人船（艇）";
      }
      if (btnText == "智能全域巡视系统") {
        seTxt = "智能全域巡视系统";
      }
      if (btnText == "全域电网巡检系统") {
        seTxt = "全域电网巡检系统";
      }
      if (btnText == "系留供电装置") {
        seTxt = "系留供电装置";
      }
      if (btnText == "无人装备便携地面站") {
        seTxt = "无人装备便携地面站";
      }
      if (btnText == "AMS-400-V112  机载任务系统") {
        seTxt = "机载任务系统";
      }
      if (btnText == "无人装备驾控台") {
        seTxt = "无人装备驾控台";
      }
      localStorage.setItem("selectedText", seTxt);
      this.setProductLocalStorage(seTxt);
      // 在 tabRouteMap 中查找 route

      const routeObj = this.tabRouteMap.find((item) => item.text === btnText);
      if (routeObj && routeObj.route) {
        this.$router.push({
          path: "/product_lie",
          query: { source: routeObj.route },
        });
      } else {
        this.$message && this.$message.warning("未找到对应产品详情页");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.product-show {
  height: 930px;
  width: 100%;
  // max-width: 1920px;
  margin: 0 auto;
  padding: 20px 20px 60px;
  text-align: center;
  background: linear-gradient(179deg, #f4f6f9 1%, #ffffff 97%);

  background-image: url("../../assets/home/bg_all.png");
  background-size: 100% 100%;
  background-position: center;

  .product-show-container {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    margin: 80px 0px 40px;
    opacity: 1;

    font-family: PingFang TC;
    font-size: 32px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0px;

    font-variation-settings: "opsz" auto;
    color: #1e242a;
  }
}

.uavLeft {
  width: 320px;
  height: 546px;
  padding: 40px;
  background-image: url("../../assets/home/bgLQ.png");
  background-size: cover;
  background-position: center;

  .uav_til {
    opacity: 1;
    text-align: left;
    font-family: PingFang TC;
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0px;

    font-variation-settings: "opsz" auto;
    color: #1e242a;
    margin-bottom: 40px;
  }
}

.el-menu-vertical-demo {
  border-right: none;
}

.uav_item {
  display: flex;
  align-items: top;
  gap: 8px;
  text-align: left;
  margin-bottom: 16px;
  font-size: 14px;

  .checkmark-icon {
    margin-top: 5px;
    width: 12px;
    height: 10px;
  }
}

.el-col:nth-child(2) {
  // height: 456PX;
  background-color: #ffffff;
  padding: 32px 0px 32px 32px;
  display: flex;
  align-items: flex-start;
  gap: 32px;
}

.button-group {
  // width: 25%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu-button {
  width: 170px;
  // height: 44PX;
  border-radius: 4px;
  padding: 10px 10px;
  border: 1px solid #dcdcdc;
  background: #ffffff;
  color: #000000;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s;

  &.active {
    background: linear-gradient(
      96deg,
      rgba(16, 111, 255, 0.1) 3%,
      rgba(16, 111, 255, 0) 98%
    );
    border: 1px solid #0f6bf6;
    color: #0f6bf6;
    font-weight: 600;
  }

  &:hover {
    border-color: #3a8bff;
    color: #3a8bff;
  }
}

.model-title {
  font-size: 20px;
  font-weight: bold;
  margin: 40px 0px 20px;
  color: #1e242a;
}

.button-details {
  // width: 75%;
  margin-top: 0;
  text-align: left;
  width: 100%;

  .model-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .model-image {
      // width: 386PX;
      // height: 290PX;
      right: -70px;
      top: 260px;
      position: absolute;
    }
  }

  .button-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 16px;
    color: #1e242a;
    opacity: 1;
  }

  .button-description {
    font-size: 16px;
    margin-bottom: 20px;
    color: #1e242a;
    text-align: justify;
    text-justify: inter-ideograph;
    -webkit-text-align-last: justify;
    // min-height: 72px;
    width: 100%;
  }

  .learn-more {
    font-size: 16px;
    color: #1e242a;
    opacity: 0.4;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .detail-buttons {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 315px;

    // 新增：当子元素大于2时，变为两列竖排
    &.two-columns {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 10px 20px;

      .detail-button {
        width: 130px;
        // 让每列最多2个，超出自动换行
        margin-bottom: 10px;
      }
    }

    .detail-button {
      width: 130px;
      min-height: 60px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 10px;
      border: 1px solid #dcdcdc;
      background: #ffffff;
      color: #000000;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 4px;

      &.active {
        border-color: #3a8bff;
      }

      &:hover {
        border-color: #3a8bff;
      }

      .detail-icon {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.custom-tabs {
  display: flex;
  // border-bottom: 2PX solid #e5e5e5;
  margin-bottom: 40px;
  justify-content: center;

  .custom-tab {
    margin: 12px 14px 0px;
    padding-bottom: 12px;
    cursor: pointer;
    font-size: 18px;
    color: rgb(30 36 42 / 80%);
    border-bottom: 2px solid transparent;
    transition: all 0.2s;
    white-space: nowrap; // 防止内容折行

    &.active {
      font-weight: 600;
      color: #0f6bf6;
      border-bottom: 2px solid #0f6bf6;
    }
  }
}

::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
